import * as yup from 'yup';
import * as mathjs from 'mathjs';

/** Common validation schema for `mathjs` library expressions */
export const mathJsExpressionSchema = yup
  .string()
  .test({
    name: 'math-js-expression',
    test: (value, context) => {
      if (!value) {
        return context.schema?.spec?.optional || context.schema?.spec?.nullable;
      }

      try {
        mathjs.compile(value);
        return true;
      } catch (error) {
        return context.createError({ message: `Неправильно составленное выражение (${error.char} символ): ${error.message}` });
      }
    },
  });
